"use strict"

const countdown = require("../libs/countdown").default;
const htmlHelper = require('../libs/htmlHelper');
const simpleModal = require("../libs/simpleModal").default;

const loadPaymentProvider = (clearing, subscriberId) => {
    const modalId = 'window-payment';
    spinner.show();
    $.ajax({
        url: '/site/groups/payment-clearing',
        data: {
            clearing: clearing,
            subscriberId: subscriberId
        },
        type: 'post',
    }).done(function (data) {

        spinner.remove();
        if (data.debug) {
            console.log(data.debug);
        }
        if (data.success) {
            if (data.windowMode === "iframe") {
                htmlHelper.changeWindowModalContent(data.message, modalId, true);
                updateCounterBlock($('#window-payment'), data.message.paymentCounterDesc)
            } else if (data.windowMode === "redirect") {
                window.location.href = data.message.body
            } else if (data.windowMode === "newWindow") {
                window.open(data.message.body, '_blank');
                closeWindow(modalId);
            }

        } else {
            if (data.message) {
                openAlert(data.message, 'error');
            }
        }
    }).fail(function () {
        closeWindow(modalId);
        spinner.remove();
        openAlert(getCommonError(), 'error');
    });
}

const updateCounterBlock = function (modal, message) {
    if (typeof message == 'undefined') {
        return
    }
    let counterBlock = modal.find('.payment-counter');
    if (message) {
        if (!counterBlock.length) {
            counterBlock = $('<div class="payment-counter">' + message + '</div>');
            counterBlock.insertAfter(modal.find('.window-head'));
        }
        let time = new Date();
        time.setSeconds(time.getSeconds() + 900);
        const countSelector = document.getElementById('paymentCountdown');
        if (countSelector) {
            const countdownInstance = new countdown(countSelector, time, () => {
                window.location.reload()
            });
            window.addEventListener("message", function (e) {
                countdownInstance.stop()
                counterBlock.html('')
            }, false)
        }
    } else {
        counterBlock.remove()
    }

}

export function showPaymentModal(subscriberId = null) {
    const modalId = 'window-payment';
    let modal = $(`#${modalId}`);

    spinner.show();
    $.ajax({
        url: '/site/groups/payment-clearing',
        data: {
            subscriberId: subscriberId,
            gid: window.gid,
        },
        type: 'get',
    }).done(function (data) {
        if (data.success) {
            spinner.remove()
            updateCounterBlock(modal, data.content.paymentCounterDesc)
            if (modal.length && !modal.hasClass('in')) {
                htmlHelper.changeWindowModalContent(data.content, modalId, true);
                openWindow(modalId, false);
            }
        } else {
            window.openAlert(data.message || '', 'error').then(() => window.location.reload());
        }
    }).fail(function () {
        window.openAlert(getCommonError(), 'error');
        spinner.remove();
    });
    return modal;
}

export function selectPaymentClearing(clearing, subscriberId) {
    loadPaymentProvider(clearing, subscriberId);
}

export function calcDiscount(price, method, value, cents = true) {
    if (typeof value == 'string') {
        value = parseFloat(value)
    }
    if (method === 'offPrice') {
        return price - (cents ? (value / 100).toFixed(2) : value)
    } else if (method === 'percentage') {
        return price - price * value / 100
    } else {
        return ''
    }
}

export function discountText(method, value, negative = false, cents = true) {
    let result = ''
    if (method === 'offPrice') {
        result = cents ? (value / 100).toFixed(2) : value
    } else if (method === 'percentage') {
        result = value + '%'
    } else {
        return ''
    }
    if (negative) {
        result = '-' + result
    }
    return result
}
